var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2861L5.30058 9.25868V6.557L0 3.91016V12.2861Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30045 14.22V10.0474L0.359863 12.8725L5.30045 14.22Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.133719 0.0701538C0.048005 0.135277 0 0.238067 0 0.344373V3.14557L5.30058 5.79585V1.349L0.432003 0.0118112C0.32915 -0.0155605 0.219434 0.00494737 0.133719 0.0701538Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98633 6.56387V9.18326L10.9303 10.3181V7.85988L7.95776 5.6416L5.98633 6.56387Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9304 7.00265V4.25293L8.66064 5.31574L10.9304 7.00265Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98633 5.80963L7.83431 4.9457C7.83431 4.94227 7.83774 4.94227 7.83774 4.94227C7.84118 4.94227 7.84804 4.93884 7.85147 4.93541C7.85488 4.93198 7.86175 4.93198 7.86518 4.93198L10.9303 3.49886V0.0771484L5.98633 1.29422V5.80963Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98633 14.2302L10.9303 13.0131V11.0211L5.98633 9.88623V14.2302Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2151 1.86006C17.2151 1.70579 17.1122 1.5686 16.9613 1.5275L11.6162 0.0805664V7.18112L17.2151 4.91832V1.86006Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2151 5.65527L11.6162 7.91808V11.4598C11.6265 11.4461 11.6368 11.4324 11.6471 11.4186C11.9042 11.117 14.2013 8.51808 17.2151 8.4358V5.65527Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5464 11.861C22.4538 11.7479 20.2081 9.11475 17.3589 9.11475C14.5132 9.11475 12.2675 11.7479 12.1715 11.861C12.0652 11.9878 12.0652 12.1764 12.1715 12.3033C12.2675 12.4164 14.5132 15.0496 17.3589 15.0496C20.2081 15.0496 22.4538 12.4164 22.5464 12.3033C22.6527 12.1764 22.6527 11.9878 22.5464 11.861ZM17.3555 13.925C16.3406 13.925 15.5109 13.0988 15.5109 12.0839C15.5109 12.0428 15.5178 12.005 15.5212 11.9673C15.5349 11.7856 15.6927 11.6073 15.8744 11.6245C15.8881 11.6245 15.9224 11.6279 15.9395 11.6313C16.1932 11.6313 16.4229 11.5422 16.5944 11.3708C16.7829 11.1822 16.8892 10.901 16.8858 10.5959C16.8824 10.4176 17.0195 10.2702 17.1978 10.2531C17.2698 10.2428 17.3144 10.2393 17.3555 10.2393C18.3738 10.2393 19.2001 11.0656 19.2001 12.0839C19.2001 13.0988 18.3738 13.925 17.3555 13.925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.c4984c52b15ea2d2a51086cabb09e136.svg";
export { ForwardRef as ReactComponent };